import GamesList from "../../lists/games/GamesList";
import GamesInComingMessage from "./GamesInComingMessage";

export default function GamesScreenContent() {
    // Used in GamesScreen to display header, games list
    // and on coming warning message

    // BUILD
    return (
        <div className={"animate-appearSlow grow w-full flex flex-col justify-start min-h-0 px-[24px]"}>
            <GamesList />
            <GamesInComingMessage />
        </div>
    );

}